import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Button,
    Input
} from "reactstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { ClassAttributes, HTMLAttributes, JSXElementConstructor, LegacyRef, ReactElement, ReactNode, ReactPortal, useEffect, useState } from "react";
import { JSX } from "react/jsx-runtime";
import ArrangeFields from "./ArrangeFields";
import { isJson } from "utils";

interface Field {
    id: string | number;
    valuesJson: string;
    [key: string]: any;
}

interface Step {
    id: string | number;
    label: string;
    tab: string;
    fields: Field[];
    extras: any;
}

interface Props {
    steps: Step[];
    onReorder: (steps: Step[]) => void;
    setFields:any;
}

const GroupedFieldsAccordion = ({
    steps,
    onReorder,
    setFields
}: Props) => {
    const [activeVerticalTab, setActiveVerticalTab] = useState<any>(undefined);
    const [orderedSteps, setOrderedSteps] = useState<Step[]>(steps);
    const [fieldsSequence, setFieldsSequence]  = useState<any>(null)
    const [sectionSequece, setSectionSequece]  = useState<any>([])
    useEffect(() => {
        setOrderedSteps(steps)
    }, [steps])
    
    const toggleVerticalTab = (tab: any) => {
        if (activeVerticalTab === tab) setActiveVerticalTab(undefined);
        else setActiveVerticalTab(tab);
    };

    const handleAccordionReorder = (result: any) => {
        if (!result.destination) return;
        const items = Array.from(orderedSteps);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setOrderedSteps(items);
        onReorder(items);
        let sectionSequece  = items?.length && items?.map((item) => item?.id)
        setSectionSequece(sectionSequece)
    };
    
    useEffect(() =>  {
        let tempfieldsSequence  = fieldsSequence || {};
        orderedSteps?.length && orderedSteps?.map((step: any) => {
            if(step?.id && step?.fields) {
                tempfieldsSequence[step?.id] = step?.fields;
            }
        })
        setFieldsSequence(tempfieldsSequence)
    }, [orderedSteps])

   

    const setFieldSequece  = (sectionId:any, sequence: any) => {
        let tempfieldsSequence  = fieldsSequence || {}
        tempfieldsSequence[sectionId] = sequence
        setFieldsSequence(tempfieldsSequence);
        let fields: any = [];
        if(sectionSequece?.length && tempfieldsSequence) 
        { sectionSequece?.map((section: string) => {
            let selected = orderedSteps.find((item) => item.id === section)
            fields.push({[section]: tempfieldsSequence[section],  extras: { ...selected?.extras, key: selected?.label, hideinView: selected?.extras?.hideinView }})
        })}
        else{
            let sectionSequece: any  = orderedSteps?.length && orderedSteps?.map((item) => item?.id)
            setSectionSequece(sectionSequece)
            sectionSequece?.length && sectionSequece?.map((section: string) => {
                let selected = orderedSteps.find((item) => item.id === section)
                fields.push({[section]: tempfieldsSequence[section],  extras: { ...selected?.extras, key: selected?.label, hideinView: selected?.extras?.hideinView }})
            })
        }
        setFields(fields)
    }

    useEffect(() => {
        let fields : any = []
        orderedSteps?.length && orderedSteps?.map((item: any) => {
            let id = item?.id;
            let sequence: any = []
            item?.fields && item?.fields.length &&
                item?.fields.map((field: any) => {
                    let item = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : {}
                    sequence.push({ id: field.id, extras: { ...field?.extras, key: item.key, hideinView: field?.extras?.hideinView } })
                })
            fields.push({[id]: sequence, extras: { ...item?.extras, key: item.key, hideinView: item?.extras?.hideinView }})
        })
        setFields(fields)
    }, [orderedSteps])

    const toggleHideInView = (field: any, index: any, checked: any) => {
        let newsteps = orderedSteps.map((item: any) => {
            if (item.id === field?.id) return { ...item, extras: { ...field?.extras, hideinView: !checked } }
            else return item
        })
        setOrderedSteps(newsteps);
        onReorder(newsteps);
    }

    return (
        <div>
            <DragDropContext onDragEnd={handleAccordionReorder}>
                <Droppable droppableId="steps-droppable" type='step'>
                    {(droppableProvided: { droppableProps: JSX.IntrinsicAttributes & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>; innerRef: LegacyRef<HTMLDivElement> | undefined; placeholder: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | Iterable<ReactNode> | null | undefined; }) => (
                        <div {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
                            {orderedSteps.map(({ tab, fields, label, extras, id}, index) => {
                                return (
                                    fields.length > 0 && <Draggable key={tab} draggableId={tab.toString()} index={index}>
                                        {(draggableProvided: { innerRef: LegacyRef<HTMLDivElement> | undefined; draggableProps: JSX.IntrinsicAttributes & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>; dragHandleProps: JSX.IntrinsicAttributes & ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement>; }) => (
                                            <div
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                                className="bg-primary-subtle d-flex align-items-center mb-1"
                                            >
                                                <span {...draggableProvided.dragHandleProps} className="mx-2 mt-1 cursor-grab">
                                                    <i className="bx bx-grid-vertical fs-5" />
                                                </span>
                                                {fields.length > 0 && (
                                                    <Accordion
                                                        className="flex-grow-1 custom-accordionwithicon accordion-fill-primary"
                                                        open={activeVerticalTab}
                                                        toggle={toggleVerticalTab}
                                                    >
                                                        <AccordionItem>
                                                            <AccordionHeader targetId={tab}>
                                                                <div className="hstack w-100 justify-content-between">
                                                                        <div>
                                                                            {label}
                                                                        </div>
                                                                        <div onClick={(e) => e.stopPropagation()} className="form-check form-switch form-check-right align-items-center d-flex mt-1 me-5">
                                                                            <Input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckRightDisabled" 
                                                                            checked={!extras?.hideinView} 
                                                                            onChange={(e) => {toggleHideInView({ tab, fields, label, extras, id}, index, e.target.checked); e.preventDefault()}} />
                                                                        </div>
                                                                </div>
                                                            </AccordionHeader>
                                                            <AccordionBody accordionId={tab}>
                                                                <ArrangeFields dataFields={fields} sectionId={id} onChange={setFieldSequece} />
                                                            </AccordionBody>
                                                        </AccordionItem>
                                                    </Accordion>
                                                )}
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {droppableProvided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
};

export default GroupedFieldsAccordion;
